<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';
import { Primitive, type PrimitiveProps } from 'reka-ui';

const props = withDefaults(defineProps<PrimitiveProps & { class?: HTMLAttributes['class'] }>(), {
  as: 'a',
});
</script>

<template>
  <Primitive :as="as" :asChild="asChild" :class="cn('transition-colors hover:text-slate-950', props.class)">
    <slot />
  </Primitive>
</template>
